import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CardAdministrationService } from '@core/card-administration/services/card-administration.service';
import { map } from 'rxjs';

@Component({
    selector: 'app-load-page',
    templateUrl: './load-page.component.html',
    styleUrls: ['./load-page.component.css'],
    standalone: false
})
export class LoadPageComponent {
  private transactionIdentifier: string = '';
  private token: string = '';

  carga1: any;
  carga2: any;
  carga3: any;
  contCarga = 8;

  constructor(
    private readonly _cardAdministrationService: CardAdministrationService,
    private readonly route: ActivatedRoute,
    private readonly router: Router
  ) {}

  ngOnInit(): void {
    this.route.queryParams
      .pipe(
        map((params) => {
          this.transactionIdentifier = params['processIdentifier'];
          this.token = params['token'];

          if (params['country']) {
            localStorage.setItem('country', params['country']);
          } else {
            localStorage.removeItem('country');
          }
        })
      )
      .subscribe();
    this.loadPage();    
  }

  loadPage(): void {
    this._cardAdministrationService
      .loadSaveProcess(this.transactionIdentifier, this.token)
      .subscribe((rspOk) => {
        if (rspOk.resultCode === 'SUCCESS') {
          localStorage.setItem('t1_merchant_id', rspOk.result.t1_merchant_id);
          localStorage.setItem('captureContext', rspOk.result.captureContext);
          localStorage.setItem('processId', rspOk.result.processId);
          this._cardAdministrationService.setAuthToken(rspOk.result.token);

          this.router.navigate(['/card-administration/', 'save-card']);
        } else {
          this.router.navigate(['/', '']);
        }
      });
  }
}
